<template>
  <div>

    <div v-loading.fullscreen.lock="fullScreenLoading"
         element-loading-text="Loading, please wait..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
    </div>

    <div class="block">
      <el-tree
        ref="tree"
        :data="structure"
        node-key="id"
        :highlight-current = "highlightCurrent"
        :default-expand-all="defaultExpandAll"
        :show-checkbox = "showCheckbox"
        @node-click="nodeClick"
        :filter-node-method="filterNode"
        empty-text="Empty Content"
        :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
           <el-tooltip :content="data[nodeName]" placement="top" :open-delay="500">
        <span class="black min-font">

          <i class="fa fa-server" aria-hidden="true" ></i>
                {{ splitTableName(data[nodeName]) }}

        </span>
                </el-tooltip>
        <span v-if="showRadio && !node.data[showRadioProperty] && node.data.id != 0">
        &nbsp;
         <el-radio v-model="radioId" :label="node.data[radioProperty]"  >  &nbsp; </el-radio>


        </span>
      </span>
      </el-tree>



    </div>

  </div>
</template>

<script>
  import util from '@/util/util.js'
  export default {
    name: "tree-radio",
    props: {

      showRadio:{
        type: Boolean,
        required: false,
        default: () => true
      },
      showCheckbox: {
        type: Boolean,
        required: false,
        default: () => false
      },
      defaultExpandAll: {
        type: Boolean,
        required: false,
        default: () => true
      },
    },
    data() {
      return {
        index: -1,
        radioId:'',
        fullScreenLoading: false,
        highlightCurrent: true,
        nodeName: '',
        radioProperty:'id',
        showRadioProperty:'isService',
        structure:[
          {
            id: '0',
            name: 'ROOT',
            children: []
          }
        ]
      }
    },
    computed: {

    },
    created(){

    },
    methods:{
      /**
       * 树的初始化函数
       * @param structure  树的标准结构
       * @param nodeName 显示叶子树形名
       * @param radioProperty radio用来选择的属性名称
       * @param showRadioProperty radio用来区分属性
       */
      init(structure, nodeName, radioProperty,showRadioProperty){
        try{
        this.nodeName = nodeName;
        if(radioProperty){
          this.radioProperty = radioProperty;
        }
        if(showRadioProperty){
          this.showRadioProperty = showRadioProperty;
        }
        this.structure[0][nodeName] = 'ROOT';
        this.structure[0].children= [];

        this.structure[0].children= structure;

        //处理下半选的情况
        // this.initIndeterminate(structure[0], readCheckedProperties, writeCheckedProperties);
        }catch(e){
          console.info(e)
        }
      },
      getNodeData(node, nodeKey){
        for(let i = 0; i< node.length; i ++){
          let nodeData = node[i];
          if (nodeData.id === nodeKey) {
            return nodeData;
          }
          if (nodeData.children && nodeData.children.length) {
            return this.getNodeData(nodeData.children, nodeKey);
          }
        }
      },

      setIndex(index){
        this.index =index;
      },
      getIndex(){
        return this.index;
      },
      filterNode(value, data) {
        if (!value) return true;
        if (data[this.nodeName]) {
          return data[this.nodeName].indexOf(value) !== -1;
        }
      },
      nodeClick(data, node, myself){
        if(node.data.id !=0 && !node.data[this.showRadioProperty] && this.showRadio){
          this.radioId = node.data[this.radioProperty];
        }

        this.$emit("nodeClick", data, node);
      },
      getStructure(){
        return this.structure;
      },
      //表名最多只显示12个字符
      splitTableName(tableName){
        if(tableName && tableName.length > 100){
          return tableName.substring(0,100) + "...";
        }
        return tableName;
      },

      setRadioId(radioId){
        this.radioId = radioId;
      },
      getRadioId(){
        return this.radioId;
      },


      inArray(arr, str) {
        let i = arr.length;
        while (i--) {
          if (arr[i] === str) {
            return true;
          }
        }
        return false;
      },
      filter(value){
        this.$refs.tree.filter(value);
      }
    }
  }
</script>

<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .black{
    color: black;
  }

  .el-button--mini, .el-button--mini.is-round {
    padding: 2px 2px;
  }


  /*.el-select {*/
  /*  width: auto !important;*/
  /*}*/

  /*.el-input {*/
  /*  width: auto !important;*/
  /*}*/
  /*.el-textarea{*/
  /*  width: auto !important;*/
  /*}*/

  .el-form-item__label {
    width: 112px;
    text-align: right !important;
  }
  .el-form--label-left /deep/ .el-form-item__label {
    width: 36%;
    text-align: right;
    font-size: 12px;
  }

  /*.el-input /deep/ .el-input__inner{*/
  /*  width: 250px;*/
  /*}*/

  /*.el-textarea /deep/ .el-textarea__inner{*/
  /*  width: 250px;*/
  /*}*/

  .el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content{
    background-color: #d7d6de;
  }
  .min-font{
    font-size: 12px;
  }

  /*/deep/ .el-textarea__inner{*/
  /*    padding: 5px 15px 10px 5px;*/
  /*}*/





</style>



// WEBPACK FOOTER //
// src/view/acs/tree/tree_radio.vue